import angular from "angular";

import { Calculation } from "@salaxy/core";
import { UiCrudHelpers, UiHelpers } from "../../../services";
import { CalculationCrudController } from "../CalculationCrudController";

/**
 * Allows editing the employmen
 */
export class CalcEmploymentController implements angular.IController {

  /**
   * For NG-dependency injection
   * @ignore
   */
  public static $inject = ["UiHelpers", "UiCrudHelpers"];

  /**
   * Setter for the calculations controller that edits the current item.
   * Possibility to support other data types.
   */
  public model: CalculationCrudController;

  /**
   * If true, will also update the calculation rows from employment relation when the employment
   * relation is selected. By default, does not update the rows.
   */
  public updateRows: boolean;

  constructor(
    private uiHelpers: UiHelpers,
    private uiCrudHelpers: UiCrudHelpers,
  ) {
    // Dependency injection
  }

  /** Gets the current calculation. By convention, set in model. */
  public get current(): Calculation {
    return this.model.current;
  }

  /**
   * Opens a dialog that shows the wizard to create a new Employment relation.
   */
  public launchEmploymentWizard(): void {
    this.uiCrudHelpers.createNewEmployment().then((result) => {
      if (result.action === "ok") {
        const loader = this.uiHelpers.showLoading("SALAXY.UI_Terms.isSaving");
        this.model.updateFromEmployment(result.item.id, this.updateRows || false).then(() => {
          loader.dismiss();
        });
      }
    });
  }
}
